"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDatesQuery = formatDatesQuery;
exports.formatDynamicContent = formatDynamicContent;
exports.formatRoomsQuery = formatRoomsQuery;
exports.formatRoomsQueryNew = formatRoomsQueryNew;
exports.formatSimilarHotels = formatSimilarHotels;
exports.generateAmenityIcon = generateAmenityIcon;
exports.generateCancellationPolicyPackages = generateCancellationPolicyPackages;
exports.generateCovidAmenities = generateCovidAmenities;
exports.generateHotelAmenities = generateHotelAmenities;
exports.getAllRoomsWithMissingContent = getAllRoomsWithMissingContent;
exports.getHealthAndSafetyAmenities = getHealthAndSafetyAmenities;
exports.getHotelDetailsUrl = getHotelDetailsUrl;
exports.getPopularCovidAmenities = getPopularCovidAmenities;
exports.getPopularHotelAmenities = getPopularHotelAmenities;
exports.getReviewScoreMeta = getReviewScoreMeta;
exports.getSortedHotelAmenities = getSortedHotelAmenities;
exports.hasHealthAndSafetyAmenities = hasHealthAndSafetyAmenities;
exports.hotelImagesWithGroupIds = hotelImagesWithGroupIds;
exports.mapDynamicToStaticContent = mapDynamicToStaticContent;
exports.translateAmenity = translateAmenity;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _slice2 = _interopRequireDefault(require("lodash/slice"));
var _reverse2 = _interopRequireDefault(require("lodash/reverse"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _dateFns = require("date-fns");
var _language = require("./language.utils");
var _similarHotel = require("../factories/similar-hotel.factory");
var _date = require("../constants/date.constants");
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * translate amenity
 * @param {Object} amenity
 * @param {String} language
 * @return {Object} translated amenity
 */
function translateAmenity(amenity, language) {
  return _objectSpread(_objectSpread({}, amenity), {}, {
    name: (0, _language.translateObjectLabel)((0, _get2["default"])(amenity, 'name'), language),
    facilities: amenity.facilities.map(function (facility) {
      return _objectSpread(_objectSpread({}, facility), {}, {
        name: (0, _language.translateObjectLabel)((0, _get2["default"])(facility, 'name'), language),
        facilityTagResponse: (0, _isPlainObject2["default"])(facility.facilityTagResponse) ? _objectSpread(_objectSpread({}, facility.facilityTagResponse), {}, {
          name: (0, _language.translateObjectLabel)((0, _get2["default"])(facility, 'facilityTagResponse.name'), language)
        }) : null
      });
    })
  });
}

/**
 * get sorted hotel amenities
 * @param {Array} amenities
 * @return {Array} sorted amenities
 */
function getSortedHotelAmenities(amenities) {
  return amenities.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      amenities: (0, _get2["default"])(item, 'facilities', [])
    });
  });
}

/**
 * get popular amenities
 * @param {Array<Object>} amenities
 * @return {Array<Object>} popular amenities
 */
function getPopularHotelAmenities(amenities) {
  var popularAmenities = amenities.reduce(function (amenities, item) {
    return [].concat((0, _toConsumableArray2["default"])(amenities), (0, _toConsumableArray2["default"])(item.facilities.filter(function (_ref) {
      var popular = _ref.popular;
      return popular;
    })));
  }, []);
  return (0, _sortBy2["default"])(popularAmenities, 'popularityRank');
}

/**
 * check healthAndSafety amenities available
 * @param {Array<Object>} amenities
 * @return {Array<Object>} popular amenities
 */
function hasHealthAndSafetyAmenities(amenities) {
  return amenities.filter(function (i) {
    return i.id >= _constants.MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES;
  }).length > 0;
}

/**
 * get healthAndSafety amenities
 * @param {Array<Object>} amenities
 * @return {Array<Object>} popular amenities
 */
function getHealthAndSafetyAmenities(amenities) {
  return amenities.filter(function (i) {
    return i.id >= _constants.MINIMUM_ID_FOR_COVID_FACILITIES;
  });
}

/**
 * get popular covid amenities
 * @param {Array<Object>} amenities
 * @return {Array<Object>} popular amenities
 */
function getPopularCovidAmenities(amenities) {
  var covidAmenities = amenities.filter(function (i) {
    return i.id >= _constants.MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES;
  });
  var popularCovidAmenities = covidAmenities.reduce(function (amenities, item) {
    return [].concat((0, _toConsumableArray2["default"])(amenities), (0, _toConsumableArray2["default"])(item.facilities.filter(function (_ref2) {
      var popular = _ref2.popular;
      return popular;
    })));
  }, []);
  return (0, _sortBy2["default"])(popularCovidAmenities, 'popularityRank');
}

/**
 * get review score meta
 * @param {Number} score
 * @param {Array<Object>} scaleReviews
 * @return {{ color: String, name: String }}
 */
function getReviewScoreMeta(score, scaleReviews) {
  return scaleReviews === null || scaleReviews === void 0 ? void 0 : scaleReviews.find(function (_ref3) {
    var start = _ref3.start,
      end = _ref3.end;
    var min = Math.min(start, end);
    var max = Math.max(start, end);
    var value = isNaN(parseFloat(score)) ? 0 : parseFloat(score);
    return value >= min && value <= max;
  });
}

/**
 * format rooms array to query string
 * @param {Array<Object>} rooms
 * @return {string}
 */
function formatRoomsQuery(rooms) {
  var query = rooms.map(function (room) {
    var adults = room.guest.filter(function (_ref4) {
      var type = _ref4.type;
      return type === _constants.PAX_TYPES.ADULT;
    });
    var children = room.guest.filter(function (_ref5) {
      var type = _ref5.type;
      return type === _constants.PAX_TYPES.CHILD;
    });
    var ages = children.map(function (_ref6) {
      var age = _ref6.age;
      return age;
    }).join('-');
    var roomQuery = "".concat(adults.length, "_adult");
    if (children.length) {
      roomQuery += ",".concat(children.length, "_child,").concat(ages, "_age");
    }
    return roomQuery;
  }).join('*');
  return "rooms=".concat(query);
}

/**
 * @param {Array<Object>} rooms
 * @returns {string}
 */
function formatRoomsQueryNew() {
  var rooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
  var query = rooms.map(function (_ref7) {
    var adultsCount = _ref7.adultsCount,
      kidsAges = _ref7.kidsAges;
    return (0, _get2["default"])(kidsAges, 'length', 0) > 0 ? "".concat(adultsCount, "_adult,").concat(kidsAges.length, "_child,").concat(kidsAges.join('-'), "_age") : "".concat(adultsCount, "_adult");
  }).join(separator);
  return "rooms=".concat(query);
}

/**
 * format dates object to query string
 * @param {Object} dates
 * @return {string}
 */
function formatDatesQuery(dates) {
  return Object.keys(dates).map(function (date) {
    return "".concat(date, "=").concat(dates[date]);
  }).join('&');
}

/**
 * get hotel details url
 * @param {Number|String} hotelId
 * @param {String} uuid
 * @param {{ checkin, checkout }} dates
 * @param {Array<Object>} rooms
 * @return {string} hotelDetails url
 */
function getHotelDetailsUrl(_ref8) {
  var hotelId = _ref8.hotelId,
    uuid = _ref8.uuid,
    dates = _ref8.dates,
    rooms = _ref8.rooms;
  var query = [];
  (0, _isString2["default"])(uuid) && query.push("uuid=".concat(uuid));
  (0, _isPlainObject2["default"])(dates) && query.push(formatDatesQuery(dates));
  (0, _isArray2["default"])(rooms) && query.push(formatRoomsQuery(rooms));
  return "hotel/details/".concat(hotelId).concat(query.length ? "?".concat(query.join('&')) : '');
}
function formatDynamicContent(_ref9) {
  var searchResults = _ref9.searchResults,
    payload = _ref9.payload;
  return (0, _map2["default"])(searchResults, function (dynamicContent) {
    return {
      hotelId: (0, _get2["default"])(dynamicContent, 'hotelId'),
      dynamicContent: dynamicContent,
      staticContent: (0, _get2["default"])(payload, "hotels.".concat((0, _get2["default"])(dynamicContent, 'hotelId')))
    };
  });
}
function mapDynamicToStaticContent(_ref10) {
  var dynamicHotelsList = _ref10.dynamicHotelsList,
    staticHotelsList = _ref10.staticHotelsList;
  var mappedList = staticHotelsList === null || staticHotelsList === void 0 ? void 0 : staticHotelsList.map(function (hotel) {
    var _dynamicHotelsList$fi = dynamicHotelsList.filter(function (h) {
        return h.hotelId === hotel.atgHotelId;
      }),
      _dynamicHotelsList$fi2 = (0, _slicedToArray2["default"])(_dynamicHotelsList$fi, 1),
      result = _dynamicHotelsList$fi2[0];
    if (result) {
      var dynamicContent = result.dynamicContent,
        staticContent = result.staticContent,
        hotelId = result.hotelId;
      return _objectSpread(_objectSpread({}, hotel), {}, {
        hotelId: hotelId,
        dynamicContent: dynamicContent,
        staticContent: staticContent,
        isExist: true
      });
    }
    return {
      isExist: false
    };
  });
  return (0, _filter2["default"])(mappedList, function (_ref11) {
    var isExist = _ref11.isExist;
    return isExist;
  });
}

/**
 * format similar hotel response
 * @param {Array<Object>} hotels
 * @param {String} currency
 * @param {Function} formatPrice
 * @param {Boolean} isAlmosafer
 * @param {Number} rooms
 * @param {Number} nights
 * @param {Number} language
 * @return {Array<Object>} formatted similar hotels
 */
function formatSimilarHotels() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hotels = _ref12.hotels,
    currency = _ref12.currency,
    formatPrice = _ref12.formatPrice,
    rooms = _ref12.rooms,
    nights = _ref12.nights,
    language = _ref12.language,
    currentHotelId = _ref12.currentHotelId,
    isPollingCompleted = _ref12.isPollingCompleted,
    staticResources = _ref12.staticResources;
  var formattedHotels = hotels.map(function (hotel) {
    var hotelId = hotel.hotelId || hotel.atgHotelId;
    var staticContent = hotel.staticContent || hotel;
    var dynamicContent = hotel.dynamicContent || hotel;
    var propertyTypesHashMap = staticResources.propertyTypesHashMap,
      _staticResources$revi = (0, _slicedToArray2["default"])(staticResources.reviewScaleHashMap, 2),
      reviewsScaleOfTen = _staticResources$revi[1];
    var similarHotel = (0, _similarHotel.similarHotelFactory)({
      hotelId: hotelId,
      dynamicContent: dynamicContent,
      staticContent: staticContent,
      currency: currency,
      formatPrice: formatPrice,
      language: language,
      rooms: rooms,
      nights: nights,
      isPollingCompleted: isPollingCompleted,
      reviewsScaleOfTen: reviewsScaleOfTen,
      propertyTypesHashMap: propertyTypesHashMap
    });
    return similarHotel;
  });
  return (0, _slice2["default"])((0, _reverse2["default"])((0, _sortBy2["default"])((0, _filter2["default"])(formattedHotels, function (_ref13) {
    var id = _ref13.id;
    return id !== currentHotelId;
  }), 'similarityScore')), 0, _constants.MAX_SIMILAR_HOTELS_COUNT);
}

/**
 *
 * @param {Number} id
 * @param {String} type
 * @returns {Object}
 */
function generateAmenityIcon(_ref14) {
  var id = _ref14.id,
    _ref14$type = _ref14.type,
    type = _ref14$type === void 0 ? 'search' : _ref14$type,
    env = _ref14.env;
  var url = function url(color) {
    return "http://hotelcms-contents-".concat(env, ".almosafer.com/amenity-").concat(type, "-").concat(color, "-").concat(id, ".png");
  };
  return {
    blackIcon: url('blackIcon'),
    greyIcon: url('greyIcon'),
    greenIcon: url('greenIcon')
  };
}

/**
 * generateHotelAmenities
 * @param {Object} param
 * @returns {Array}
 */
function generateHotelAmenities(_ref15) {
  var hotelAmenitiesIds = _ref15.hotelAmenitiesIds,
    amenityCategoriesHashMap = _ref15.amenityCategoriesHashMap,
    amenityTagsHashMap = _ref15.amenityTagsHashMap,
    amenitiesHashMap = _ref15.amenitiesHashMap,
    env = _ref15.env;
  var formattedAmenities = hotelAmenitiesIds.map(function (facilityCategory) {
    var id = (0, _get2["default"])(facilityCategory, 'id');
    var facilities = (0, _get2["default"])(facilityCategory, 'facilities', []).map(function (_ref16) {
      var id = _ref16.id,
        facilityTagResponseId = _ref16.facilityTagResponseId;
      var amenity = amenitiesHashMap[id];
      return _objectSpread(_objectSpread(_objectSpread({}, amenity), generateAmenityIcon({
        id: id,
        env: env
      })), {}, {
        facilityTagResponse: amenityTagsHashMap[facilityTagResponseId] || null
      });
    });
    return _objectSpread(_objectSpread(_objectSpread({}, amenityCategoriesHashMap[id]), generateAmenityIcon({
      id: id,
      type: 'category',
      env: env
    })), {}, {
      facilities: (0, _sortBy2["default"])(facilities, ['rank'])
    });
  });
  return (0, _sortBy2["default"])((0, _filter2["default"])(formattedAmenities, function (_ref17) {
    var facilities = _ref17.facilities;
    return facilities === null || facilities === void 0 ? void 0 : facilities.length;
  }), 'rank');
}

/**
 * generateCovidAmenities
 * @param {Object} param
 * @returns {Array}
 */
function generateCovidAmenities(_ref18) {
  var hotelAmenitiesIds = _ref18.hotelAmenitiesIds,
    amenityCategoriesHashMap = _ref18.amenityCategoriesHashMap,
    amenityTagsHashMap = _ref18.amenityTagsHashMap,
    amenitiesHashMap = _ref18.amenitiesHashMap,
    env = _ref18.env;
  var covidAmenities = hotelAmenitiesIds.filter(function (i) {
    return i.id >= _constants.MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES;
  });
  var formattedAmenities = covidAmenities.map(function (facilityCategory) {
    var id = (0, _get2["default"])(facilityCategory, 'id');
    var facilities = (0, _get2["default"])(facilityCategory, 'facilities', []).map(function (_ref19) {
      var id = _ref19.id,
        facilityTagResponseId = _ref19.facilityTagResponseId;
      var amenity = amenitiesHashMap[id];
      return _objectSpread(_objectSpread(_objectSpread({}, amenity), generateAmenityIcon({
        id: id,
        env: env
      })), {}, {
        facilityTagResponse: amenityTagsHashMap[facilityTagResponseId] || null
      });
    });
    return _objectSpread(_objectSpread(_objectSpread({}, amenityCategoriesHashMap[id]), generateAmenityIcon({
      id: id,
      type: 'category',
      env: env
    })), {}, {
      facilities: (0, _sortBy2["default"])(facilities, ['rank'])
    });
  });
  return (0, _sortBy2["default"])(formattedAmenities, 'rank');
}
/**
 * getAllRoomsWithMissingContent
 * @param {Array} roomsList
 * @param {Array} missingIdsTemplatesHashCodes
 */
function getAllRoomsWithMissingContent(_ref20) {
  var roomsList = _ref20.roomsList,
    missingIdsTemplatesHashCodes = _ref20.missingIdsTemplatesHashCodes,
    templatesWithMissingContent = _ref20.templatesWithMissingContent;
  var roomsWithMissingContent = (0, _filter2["default"])(roomsList, function (room) {
    return templatesWithMissingContent.includes(room.templateInfo.templateId);
  });
  return (0, _uniqBy2["default"])([].concat((0, _toConsumableArray2["default"])((0, _map2["default"])(roomsWithMissingContent, function (room) {
    return (0, _pick2["default"])((0, _get2["default"])(room, 'templateInfo.debug', {}), ['id', 'roomHashCode']);
  })), (0, _toConsumableArray2["default"])(missingIdsTemplatesHashCodes)), 'id');
}

// Generate CancellationPolicy Groups of Packages  --- Start
// First cheapest package (FCP).
// For documentation of Below logic refer https://data4altayyargroup.atlassian.net/wiki/spaces/FRON/pages/3490185221/Room+Selection

/**
 * generate CancellationPolicy Groups of Packages
 * @param {Array} groupedRoomsPackages
 * @param {Function} formatPrice
 */
function generateCancellationPolicyPackages(_ref21) {
  var groupedRoomsPackages = _ref21.groupedRoomsPackages,
    formatPrice = _ref21.formatPrice;
  var newGroupPackages = groupedRoomsPackages.map(function (groupPackage) {
    var newGroupPackage = _objectSpread(_objectSpread({}, groupPackage), {}, {
      cancellationPolicyPackages: generateCPPackages({
        groupPackage: groupPackage,
        formatPrice: formatPrice
      })
    });
    return newGroupPackage;
  });
  return newGroupPackages;
}

/**
 * generate refundable and non-refundable Packages for each Group
 * @param {Array} groupedRoomsPackages
 * @param {Function} formatPrice
 * @returns {Array} // Result of Generated Refunable and and non refundable packages
 */
function generateCPPackages(_ref22) {
  var groupPackage = _ref22.groupPackage,
    formatPrice = _ref22.formatPrice;
  var hasRefundable = (0, _some2["default"])(groupPackage.packages, 'hasFreeCancellation');
  var hasNonRefundable = (0, _some2["default"])(groupPackage.packages, function (packages) {
    return packages.hasFreeCancellation === false;
  });

  // First Cheapest Price - FCP
  var firstCheapestPrice = groupPackage.cheapestPackagePrice;
  var firstCheapestPkg = groupPackage.packages[0];

  //  Calculate the refundable price except FCP
  var firstRFPrice = (0, _get2["default"])(findFirstRFPriceExceptFirst({
    groupPackage: groupPackage,
    firstCheapestPkg: firstCheapestPkg
  }), 'rateInfo.finalRate', '');

  // Below we check hasNonRefundable to set refundablePrice to '0' when group does not have non refundable
  var refundablePrice = hasNonRefundable ? firstRFPrice ? Math.abs(firstCheapestPrice - firstRFPrice) : 0 : 0;

  // Base Price: FCP - Identified CP of FCP
  var basePrice = firstCheapestPkg && firstCheapestPkg.hasFreeCancellation ? firstCheapestPrice - refundablePrice : firstCheapestPrice;

  // Construct Refundable and Non Refundable Packages
  var refundablePackages = groupPackage === null || groupPackage === void 0 ? void 0 : groupPackage.packages.filter(function (pkg) {
    return pkg.hasFreeCancellation;
  }).map(function (pkg) {
    var newPkg = _objectSpread(_objectSpread({}, pkg), {}, {
      mealPrice: formatPrice(Math.abs(pkg.rateInfo.finalRate - (basePrice + refundablePrice)), 0),
      isSelected: pkg.packageId === firstCheapestPkg.packageId
    });
    return newPkg;
  });
  var nonRefundablePackages = groupPackage.packages.filter(function (pkg) {
    return !pkg.hasFreeCancellation;
  }).map(function (pkg) {
    var newPkg = _objectSpread(_objectSpread({}, pkg), {}, {
      mealPrice: formatPrice(Math.abs(pkg.rateInfo.finalRate - basePrice), 0),
      isSelected: pkg.packageId === firstCheapestPkg.packageId
    });
    return newPkg;
  });

  // Selected Cancellation Policy
  var selectedCancellationPolicy = {
    refundable: firstCheapestPkg.hasFreeCancellation,
    nonRefundable: !firstCheapestPkg.hasFreeCancellation
  };

  // To Find Future Nearest Refundable Date
  var nearestRefundPkg = getNearestRefundDatePkgByFindDate(refundablePackages, (0, _dateFns.format)(new Date(), _date.DATE_FORMATS.YYYY_MM_DD));

  // To meal types available
  var mealTypes = getMealTypesAvailable(groupPackage.packages);
  return {
    hasRefundable: hasRefundable,
    hasNonRefundable: hasNonRefundable,
    refundablePrice: formatPrice(refundablePrice, 0),
    // To Convert the amount based on currency
    nonRefundablePrice: 0,
    basePrice: formatPrice(basePrice, 0),
    // To Convert the amount based on currency
    refundablePackages: refundablePackages,
    nonRefundablePackages: nonRefundablePackages,
    defaultSelectedPkg: firstCheapestPkg,
    selectedPkg: firstCheapestPkg,
    selectedCancellationPolicy: selectedCancellationPolicy,
    nearestRefundPkg: nearestRefundPkg,
    mealTypes: mealTypes
  };
}

/**
 * findFirstRFPriceExceptFirst -- refundable price except FCP
 * @param {Object} groupedRoomsPackages
 * @param {Object} firstCheapestPkg
 */

function findFirstRFPriceExceptFirst(_ref23) {
  var groupPackage = _ref23.groupPackage,
    firstCheapestPkg = _ref23.firstCheapestPkg;
  var pkgWithRefund = (0, _find2["default"])(groupPackage.packages, function (packages) {
    if (packages && packages.packageId !== firstCheapestPkg.packageId && packages.hasFreeCancellation) {
      return true;
    }
    return false;
  });
  return pkgWithRefund || 0;
}

/**
 * getNearestRefundDatePkgByFindDate -- Find Nearest Future Refundable package
 * @param {Array} refundablePackages
 * @param {Date} todayDate
 */

function getNearestRefundDatePkgByFindDate(refundablePackages, todayDate) {
  var sortedByDiff = (0, _toConsumableArray2["default"])(refundablePackages).sort(function (a, b) {
    // Sort by the absolute difference
    return Math.abs(new Date(a.cancellationPolicy.freeCancellationBefore) - new Date(todayDate)) - Math.abs(new Date(b.cancellationPolicy.freeCancellationBefore) - new Date(todayDate));
  });
  // Return the first date (the one with the smallest difference)
  return sortedByDiff[0];
}

/**
 * getMealTypesAvailable -- Find total meals in all packages
 * @param {Array} groupPackage
 */

function getMealTypesAvailable(groupPackage) {
  var nonRefundableMeals = [];
  var nonRefundableNotMeals = [];
  var refundableMeals = [];
  var refundableNotMeals = [];
  var mealTypes = [];
  groupPackage.forEach(function (pkg) {
    if (!mealTypes.includes(pkg.title)) {
      mealTypes.push(pkg.title);
    }
    if (!nonRefundableMeals.includes(pkg.title) && !pkg.hasFreeCancellation) {
      nonRefundableMeals.push(pkg.title);
    }
    if (!refundableMeals.includes(pkg.title) && pkg.hasFreeCancellation) {
      refundableMeals.push(pkg.title);
    }
  });
  mealTypes.forEach(function (item) {
    if (!nonRefundableMeals.includes(item)) {
      nonRefundableNotMeals.push((0, _defineProperty2["default"])({}, item, true));
    }
    if (!refundableMeals.includes(item)) {
      refundableNotMeals.push((0, _defineProperty2["default"])({}, item, true));
    }
  });
  return {
    mealTypes: mealTypes,
    nonRefundableNotMeals: nonRefundableNotMeals,
    refundableNotMeals: refundableNotMeals
  };
}

// Generate CancellationPolicy Groups of Packages  --- End

function hotelImagesWithGroupIds(_ref24) {
  var imageGroupHashMap = _ref24.imageGroupHashMap,
    images = _ref24.images,
    categoriesImagesSize = _ref24.categoriesImagesSize;
  if ((imageGroupHashMap === null || imageGroupHashMap === void 0 ? void 0 : imageGroupHashMap.length) > 0) {
    var filteredFilterInit = imageGroupHashMap.filter(function (item) {
      return images.some(function (responseItem) {
        return (responseItem === null || responseItem === void 0 ? void 0 : responseItem.imageGroupId) === item.id;
      });
    });
    return (0, _map2["default"])(filteredFilterInit, function (imageGroup) {
      var _categoriesImagesSize;
      return _objectSpread(_objectSpread({}, imageGroup), {}, {
        isSelected: false,
        imagesLength: (_categoriesImagesSize = categoriesImagesSize[imageGroup === null || imageGroup === void 0 ? void 0 : imageGroup.groupRanking]) === null || _categoriesImagesSize === void 0 ? void 0 : _categoriesImagesSize.sizeImages
      });
    });
  }
  return [];
}